import { contentHabitat as Component } from './content';
export default Component;
